import { render } from "./OrganizationFormSchool.vue?vue&type=template&id=e3e3c72c"
import script from "./OrganizationFormSchool.vue?vue&type=script&lang=js"
export * from "./OrganizationFormSchool.vue?vue&type=script&lang=js"

import "./OrganizationFormSchool.vue?vue&type=style&index=0&id=e3e3c72c&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__